

import { trasabilidadApi } from "../../apis";
import Swal from "sweetalert2";





export const trazabilidadXItem = async(id) => {
    try {
        const { data } = await trasabilidadApi.get(`/xitem/${id}`);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}

